/**CORE LIBRARIES IMPORT */
import React from "react";

/** Simple line icons drawn for this site (not template assets). */
const paths = {
  flame: (
    <>
      <path d="M12 3c1 3.5 5 5.5 5 10a5 5 0 0 1-10 0c0-2.4 1.2-3.8 2.3-5 .3 1.6 1 2.6 2 3 0-3 .2-5.5.7-8z" />
      <path d="M3 21h18" />
    </>
  ),
  grill: (
    <>
      <path d="M4 10h16a8 8 0 0 1-16 0zM8 18l-2 3M16 18l2 3" />
      <path d="M9 3c-1 1.2 1 2 0 3.3M13 3c-1 1.2 1 2 0 3.3" />
    </>
  ),
  pub: (
    <>
      <path d="M6 7h10v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zM16 10h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2" />
      <path d="M6 7a3 3 0 0 1 5-2.2A3 3 0 0 1 16 7" />
    </>
  ),
  celebrate: (
    <>
      <path d="M4 20l5-13 8 8z" />
      <path d="M14 4l1 2M19 9l-2 1M18 4l-2 3" />
    </>
  ),
  birthday: (
    <>
      <path d="M4 21h16M5 21v-7h14v7M5 17c2 1.3 3.5 1.3 5 0 1.5 1.3 3 1.3 4.5 0 1.5 1.3 3 1.3 4.5 0" />
      <path d="M12 14v-4M12 6c-.8.8-.8 1.6 0 2.2.8-.6.8-1.4 0-2.2z" />
    </>
  ),
  party: (
    <>
      <path d="M8 3h8l-1 7a3 3 0 0 1-6 0zM12 13v6M9 21h6" />
    </>
  ),
  candle: (
    <>
      <path d="M9 10h6v11H9zM6 21h12" />
      <path d="M12 3c-1.3 1.6-1.3 3 0 4.5 1.3-1.5 1.3-2.9 0-4.5z" />
    </>
  ),
  catering: (
    <>
      <path d="M3 17h18M5 17a7 7 0 0 1 14 0M12 8V6M10 6h4M2 20h20" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="1.5" />
      <path d="M3 7l9 6 9-6" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  music: (
    <>
      <path d="M9 18V6l11-2v12" />
      <circle cx="6.5" cy="18" r="2.5" />
      <circle cx="17.5" cy="16" r="2.5" />
    </>
  ),
  plate: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4.5" />
    </>
  ),
};

const Icon = ({ name, size = 28, className = "" }) => (
  <svg
    className={`icon ${className}`}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {paths[name]}
  </svg>
);

export default Icon;
